import { EventEmitter } from 'events';
const fetchingData = new EventEmitter();

export { fetchingData };
